import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Zap } from "lucide-react";
import SubPageNav from "../components/SubPageNav";

export default function Karriere() {
  return (
    <div className="min-h-screen bg-brand-bg py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <SubPageNav />

        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4 tracking-tighter">
          Karriere bei Strombaron
        </h1>
        <p className="text-brand-muted text-base sm:text-lg max-w-2xl">
          Werde Teil unseres Vertriebsteams – digital, flexibel und im Auftrag der Teleson AG.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 mt-10 items-start">
          {/* Ansprechpartner-Karte */}
          <div className="lg:col-span-2">
            <div className="bg-brand-surface border border-brand-line rounded-2xl p-5 shadow-[0_6px_24px_-12px_rgba(0,0,0,0.15)]" data-testid="contact-person-card">
              <div className="aspect-square rounded-xl overflow-hidden bg-brand-paper border border-brand-line">
                <img
                  src="/ansprechpartner.jpg"
                  alt="Menal Zeynal Akkurt – Inhaber Strombaron"
                  className="w-full h-full object-cover"
                  data-testid="contact-person-photo"
                />
              </div>
              <div className="mt-4">
                <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-brand-energyHover">Ihr Ansprechpartner</p>
                <p className="font-heading text-xl font-bold text-brand-ink mt-1">Menal Zeynal Akkurt</p>
                <p className="text-sm text-brand-muted mt-0.5">Inhaber &amp; Ansprechpartner Strombaron</p>
                <a
                  href="mailto:info@strombaron.de?cc=derstrombaron@gmail.com&subject=Initiativbewerbung%20Strombaron"
                  className="mt-4 w-full btn-primary rounded-full px-5 py-2.5 text-sm font-semibold inline-flex items-center justify-center gap-2"
                  data-testid="karriere-apply-btn"
                >
                  <Mail className="w-4 h-4" />
                  Jetzt bewerben
                </a>
              </div>
            </div>
          </div>

          {/* Inhalt */}
          <div className="lg:col-span-3 space-y-5 text-brand-muted leading-relaxed">
            <div className="inline-flex items-center gap-2 bg-brand-inverse text-brand-onInverse px-3 py-1.5 rounded-full text-[11px] font-semibold tracking-wide">
              <Zap className="w-3.5 h-3.5 text-brand-energy" />
              OFFIZIELL IM AUFTRAG DER TELESON AG
            </div>

            <p>
              Strombaron vermittelt Strom- und Gastarife im Auftrag der Teleson AG.
            </p>
            <p>
              Aufgrund der hohen Nachfrage bauen wir unser Vertriebsteam weiter aus. Wir bieten
              interessierten Personen die Möglichkeit, sich <strong className="text-brand-ink">unverbindlich und kostenlos</strong> in
              die Vermittlung von Energieverträgen einarbeiten zu lassen.
            </p>
            <p>
              Alle Inhalte und Schulungen werden <strong className="text-brand-ink">digital</strong> zur Verfügung gestellt.
            </p>
            <p>
              Wenn Sie Interesse haben, selbst als Vermittler im Auftrag von Strombaron tätig zu
              werden, freuen wir uns über Ihre <strong className="text-brand-ink">Initiativbewerbung</strong>.
            </p>

            {/* Mail-CTA Block */}
            <div className="mt-6 bg-brand-surface border border-brand-line rounded-2xl p-5">
              <p className="text-[11px] uppercase tracking-[0.15em] font-semibold text-brand-muted">E-Mail für Bewerbungen</p>
              <a
                href="mailto:info@strombaron.de?cc=derstrombaron@gmail.com&subject=Initiativbewerbung%20Strombaron"
                className="mt-1 inline-block font-heading text-xl font-bold text-brand-ink hover:text-brand-energyHover transition-colors"
                data-testid="karriere-mail-link"
              >
                info@strombaron.de
              </a>
            </div>

            {/* Benefits */}
            <ul className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2">
              {[
                { id: "digital", label: "100% digital", desc: "Schulungen online" },
                { id: "free", label: "Kostenlos", desc: "Keine Eintrittskosten" },
                { id: "flexible", label: "Flexibel", desc: "Nebenberuflich möglich" },
              ].map((b) => (
                <li
                  key={b.id}
                  className="bg-brand-surface border border-brand-line rounded-xl p-4 hover:border-brand-energy transition-colors"
                >
                  <p className="font-heading font-bold text-brand-ink text-sm">{b.label}</p>
                  <p className="text-xs text-brand-muted mt-0.5">{b.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
